import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface CoreValue {
  icon: string;
  title: string;
  description: string;
  color: string;
}

interface CoreValuesProps {
  values: CoreValue[];
}

const CoreValues: React.FC<CoreValuesProps> = ({ values }) => {
  return (
    <section className="py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl mb-4 text-neutral-50">
            Core Values
          </h2>
          <p className="text-lg max-w-3xl mx-auto text-neutral-50">
            The fundamental principles that guide every decision and action in my leadership approach
          </p>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map((value, index) =>
          <div
            key={index}
            className="bg-card rounded-2xl p-6 shadow-subtle hover:shadow-elevated transition-all duration-300 border border-border group hover:-translate-y-1">

              <div className={`w-14 h-14 ${value.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={value.icon as any} size={28} className="text-white" />
              </div>
              <h3 className="font-heading font-bold text-xl text-primary mb-3">
                {value.title}
              </h3>
              <p className="text-text-secondary leading-relaxed">
                {value.description}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default CoreValues;